import TermsOfUseModal from './TermsOfUseModal';

export default TermsOfUseModal;